import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { Hostel, ImageRef } from '@app/services/api/api.service';
import { EnvironmentService } from '@app/environment.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-hostel-image-grid',
  templateUrl: './hostel-image-grid.component.html',
  styleUrls: ['./hostel-image-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class HostelImageGridComponent {
  @Input()
  public hostel: Hostel;
  public coverImage: ImageRef | undefined;
  public top4Images: ImageRef[] = [];
  public totalImages: number = 0;  // Track total number of images
  public allImages: ImageRef[] = []; // Store all images for the carousel
  public currentImageIndex: number = 0;
  public isModalOpen: boolean = false; // Track modal state

  constructor(
    public environment: EnvironmentService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  get isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hostel'] && changes['hostel'].currentValue) {
      const images = this.hostel?.propertyImages || [];
      this.totalImages = images.length;  // Track total number of images
      this.coverImage = images.find((img) => img.isCoverImage) || images[0];
      this.top4Images = images.filter((img) => !img.isCoverImage).slice(0, 4);
      console.log(this.top4Images);
      this.allImages = images; // Store all images for the carousel
    }
  }

  // Handle the 'View all photos' button click

  public get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public trackByFileName(i: number, img: ImageRef) {
    return img.fileName;
  }

  openModal() {
    this.isModalOpen = true;
    this.currentImageIndex = 0; // Start carousel at the first image
  }

  closeModal() {
    this.isModalOpen = false;
  }

  nextImage() {
    if (this.currentImageIndex < this.allImages.length - 1) {
      this.currentImageIndex++;
    } else {
      this.currentImageIndex = 0; // Loop back to the first image
    }
  }

  clickOutside(event: MouseEvent): void {
    if (this.isModalOpen) {
      this.closeModal();
    }
  }

  previousImage() {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
    } else {
      this.currentImageIndex = this.allImages.length - 1; // Loop to the last image
    }
  }

  get currentImage(): string {
    console.log(this.allImages[this.currentImageIndex]);
  
    return this.allImages[this.currentImageIndex].fileName;
  }
}
